const MAIN_URL = 'https://george-fx.github.io/beshop_api/';

export const GET_ORDERS = `${MAIN_URL}api/orders.json`;
export const GET_REVIEWS = `${MAIN_URL}api/reviews.json`;
export const GET_BANNERS = `${MAIN_URL}api/banners.json`;
export const GET_PRODUCTS = `${MAIN_URL}api/products.json`;
export const GET_PROMOCODES = `${MAIN_URL}api/promocodes.json`;
export const GET_CATEGORIES = `${MAIN_URL}api/categories.json`;

export const URLS = {
  GET_ORDERS,
  GET_BANNERS,
  GET_REVIEWS,
  GET_PRODUCTS,
  GET_PROMOCODES,
  GET_CATEGORIES,
};
